
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { profile } from '../../Images';
import { changePassword } from '../../Service/UserService';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';

const { $ } = window;
function Profile() {
    
    let { userInfo } = useSelector(state => state.auth);
    const [password_data, setPasswordData] = useState({
        password:"",
        new_password:"",
        confirm_new_password:""
    })

    const [state, setState] = useState({
        processing: false
    })

    const openChangePasswordModal = (e) => {
        e.preventDefault();
        $('#modal-change').modal();
    }

    const changeUserPassword = (e) => {
        e.preventDefault();
        setState({...state, processing:true})
        if(password_data.new_password !== password_data.confirm_new_password){
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "Password confirmation must be the same"
            }).then(() =>   setState({...state, processing:false}));

            return;
        }

        delete password_data.confirm_new_password; 
         changePassword(password_data).then(res => {
            if(res.data.status == 200){
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: res.data.message
                }).then(r => $("#modal-change").modal('hide'));
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: res.data.message
                })

                return;
            }
        }).catch(err => {
            let msg = err.response.data.message? err.response.data.message: "Unknown error occured";
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: msg
            });
        }).finally(() => {
            setState({...state, processing:false})
        });
    }

    return (
        <div className="content-wrapper">
            <div className="row">
                <div className="col-lg-7">
                    <h1 className="page-title" style={{paddingLeft: 25}}>Account Settings - Profile</h1>
                </div>
                
            </div>
            <section className="content">
                <div id="modal-change" className='modal fade'>
                        <Overlay display={state.processing} />
                        <form name="form-customer" onSubmit={(e) => changeUserPassword(e)}>
                            <div className='modal-dialog modal-dialog-centered modal-lg' style={{ maxWidth: 1200 }}>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <h5 className="modal-title"> Change Password</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className='modal-body' style={{ paddingLeft: 40 }}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                        <label htmlFor="">Old password</label>
                                                        <input type="password" className="form-control"  value= {password_data.password} onChange={(e) => setPasswordData({...password_data, password:e.target.value})} placeholder="Enter user ID" required/>
                                                </div>
                                                <div className="form-group" >
                                                    <label htmlFor="">New Password</label>
                                                    <input type="password" className="form-control" value={password_data.new_password} onChange={(e) => setPasswordData({...password_data, new_password:e.target.value})} placeholder="Enter password" required/>
                                                </div>
                                                <div className="form-group" >
                                                    <label htmlFor="">Confirm New Password</label>
                                                    <input type="password" className="form-control" value={password_data.confirm_new_password} onChange={(e) => setPasswordData({...password_data, confirm_new_password:e.target.value})} placeholder="Enter password" required/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal"><i className="fa fa-times"></i> Cancel</button>
                                        {
                                            (!false) && <button className='btn btn-dark' type="submit" style={{ width: 150 }}><i className="fa fa-save"></i> Save</button>
                                        }
                                    </div>

                                </div>
                            </div>
                        </form>
                </div>
                <div className="container-fluid">
                <div className="row">
                            <div className="col-xl-4">
                                <div className="card mb-4 mb-xl-0">
                                    <div className="card-header">Profile Picture</div>
                                    <div className="card-body text-center">
                                        <img className="img-account-profile rounded-circle mb-2" src={profile} alt="" />
                                        <div className="small font-italic text-muted mb-4">JPG or PNG no larger than 1 MB</div>
                                        {/* <button className="btn btn-primary" type="button">Upload new image</button> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-8">
                                <div className="card mb-4">
                                    <div className="card-header">Account Details</div>
                                    <div className="card-body">
                                        <form>
 
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="user_id">User ID</label>
                                                    <input className="form-control" id="user_id" type="text" placeholder="" value={userInfo.user_id} readOnly />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputUsername">Full Name</label>
                                                    <input className="form-control" id="inputUsername" type="text" placeholder="" value={userInfo.user_name} readOnly />
                                                </div>
                                            </div>
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputFirstName">MHC</label>
                                                    <input className="form-control" id="inputFirstName" type="text" placeholder="" value={userInfo.BPLFrName} readOnly />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputLastName">BPLName</label>
                                                    <input className="form-control" id="inputLastName" type="text" placeholder="" value={userInfo.BPLName} readOnly />
                                                </div>
                                            </div>
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputOrgName">SAP User Code</label>
                                                    <input className="form-control" id="inputOrgName" type="text" placeholder="" value={userInfo.user_sap_code} readOnly />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputLocation">Net Discount</label>
                                                    <input className="form-control" id="inputLocation" type="text" placeholder="" value={userInfo.net_discount} readOnly />
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="small mb-1" for="inputEmailAddress">Email address</label>
                                                <input className="form-control" id="inputEmailAddress" type="email" placeholder="" value={userInfo.email} readOnly />
                                            </div>
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputPhone">Role</label>
                                                    <input className="form-control" id="inputPhone" type="tel" placeholder="" value={userInfo.role_name} readOnly/>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="small mb-1" for="inputBirthday">Default Warehouse</label>
                                                    <input className="form-control" id="inputBirthday" type="text" name="warehouse" placeholder="" value={userInfo.warehouse_stock_name} readOnly/>
                                                </div>
                                            </div>
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-6">
                                                    <a onClick={(e) => openChangePasswordModal(e)} style={{color: "blue", cursor: "pointer"}}>Change Password</a>
                                                </div>
                                            </div>
                                            {/* <button className="btn btn-primary" type="button">Save changes</button> */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </section>
        </div>
    )
}

export default Profile